import { Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "sps-card-footer",
    templateUrl: "./sps-card-footer.component.html",
    encapsulation: ViewEncapsulation.Emulated
})
export class SpsCardFooterComponent {
    @HostBinding("class.sps-card__footer") readonly _classSpsCardFooter = true;
}
